<script>
  export default {
    name: 'Autocomplete',

    props: {
      items: {
        type: Array,
        required: false,
        default: () => [],
      },
      isAsync: {
        type: Boolean,
        required: false,
        default: false,
      },
      placeholder:{
        type: String,
        required:false,
        default:"Teclea la palabra de búsqueda"
      },
      text:{
        type:String,
        required:false,
        default:'name'
      },
      //key: cada elemento, se le establecerá el icono, name: 'mdi-icon-name'
      // { key: '', name: '', color: '', title: ''}
      icon:{
        type:Object,
        required:false,
      },
    },

    data() {
      return {
        isOpen: false,
        results: [],
        search: '',
        isLoading: false,
        arrowCounter: -1,
        selected:{},
        name: 'name',
      };
    },
    beforeMount() {
      if (this.text && this.text != 'name') {
        this.name = this.text;
      }
    },
    methods: {
      onChange() {
        // Let's warn the parent that a change was made
        this.$emit('change',this.search);
        // Is the data given by an outside ajax request?
        if (this.isAsync) {
          this.isLoading = true;
        } else {
          // Let's  our flat array
          this.filterResults();
          this.isOpen = true;
        }
      },

      filterResults() {
        // first uncapitalize all the things
        this.results = this.items.filter((item) => {
          return item[this.name].toLowerCase().indexOf(this.search.toLowerCase()) > -1;
        });
      },
      setResult(result) {
        this.selected=result;
        this.search = result[this.name];
        this.isOpen = false;
        this.$emit('selected',result);
      },
      onEnter() {
        if( this.selected&&this.arrowCounter>-1){
          this.setResult(this.results[this.arrowCounter]);
          this.arrowCounter = -1;
        }
      },
      onArrowDown(evt) {
        if (this.arrowCounter < this.results.length) {
          this.arrowCounter = this.arrowCounter + 1;
        }
        let li = document.querySelector(".is-active")
        if(li){
          let div = document.getElementById('autocomplete-results');
          if((li.offsetTop-li.offsetHeight)>div.clientHeight)
            div.scrollTop = li.offsetTop-li.offsetHeight*2;//div.scrollHeight - div.clientHeight;
        }
      },
      onArrowUp() {
        let li = document.querySelector(".is-active")

        if(li){
          let div = document.getElementById('autocomplete-results');
          if((div.scrollTop-li.offsetHeight)>0)
            div.scrollTop -= li.offsetHeight;//div.scrollHeight - div.clientHeight;
            else  if(div.scrollTop!=0) div.scrollTop=0;
        }

        if (this.arrowCounter > 0) {
          this.arrowCounter = this.arrowCounter -1;
        }
      },
      handleClickOutside(evt) {
        if (!this.$el.contains(evt.target)) {
          this.isOpen = false;
          this.arrowCounter = -1;
          evt.preventDefault();
          evt.stopPropagation();
          this.$emit('close')
        }
      },
      focus:function(){
        this.$refs["input"].focus();
      },
      clean:function(){
        if (this.search.length>0) {
          this.search='';
          this.$emit('clear',null);
        }
      }
    },
    watch: {
      items: function (val, oldValue) {
        // actually compare them
        if (val.length !== oldValue.length) {
          this.results = val;
          this.isLoading = false;
        }
      },
    },
    mounted() {
      document.addEventListener('click', this.handleClickOutside)
      this.focus();
    },
    destroyed() {
      document.removeEventListener('click', this.handleClickOutside)
    }
  };
</script>

<template>
  <div class="autocomplete">
    <input
      type="text"
      @input="onChange"
      v-model="search"
      ref="input"
      @keydown.down="onArrowDown"
      @keydown.up="onArrowUp"
      @keydown.enter="onEnter"
      @keydown.esc="$emit('close')"
      v-bind:placeholder="placeholder"
    />
    <v-btn class="clear-icon" icon v-if="selected && selected[name] && search && search != ''" style="" @click="clean"> <v-icon>mdi-close</v-icon></v-btn>
    <div class="progress" v-if="isAsync"><div class="indeterminate"></div> </div>
    <ul
      id="autocomplete-results"
      v-show="isOpen"
      class="autocomplete-results"
    >
      <li
        class="loading"
        v-if="isLoading"
      >
        Loading results...
      </li>
      <li
        v-else
        v-for="(result, i) in results"
        :key="i"
        @click="setResult(result)"
        class="autocomplete-result"
        :class="{ 'is-active': i === arrowCounter }"
      >
        <span v-if="icon && icon.key && !result[icon.key]" class="mr-4"></span>
        <v-icon  v-if="icon && icon.key && result[icon.key]"  :title="icon.title?icon.title:''" :color="icon.color" small>{{icon.name}}</v-icon>

        {{ result[name] }}
      </li>
    </ul>
  </div>
</template>

<style>
  .autocomplete {
    position: relative;
  }
  .clear-icon {
    align-items: center;
    display: inline-flex;
    height: 24px;
    flex: 1 0 auto;
    justify-content: center;
    min-width: 24px;
    width: 24px;
    position: absolute;
    margin-left: -35px;
    margin-top: 10px;
  }

  .autocomplete-results {
    padding: 0 0px 0px 0;
    margin: 0 8px 8px 8px;
    border: 1px solid lightblue;
    background-color: #fbfcfc;
    height: 120px;
    overflow-y: scroll;

  }

  .autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
  }

  .autocomplete-result.is-active{
    background-color: #80CBC4;
    color: white;
  }

  .autocomplete-result:hover {
    background-color:lightcyan;
    color: black;
  }


  .autocomplete input {
    margin: 8px 0;
    padding: 4px 8px 4px 8px;
    height: 40px;
    width: 95%;
    border:1px solid darkgray;
    background-color: white;
    border-radius: 4px;
  }
  .autocomplete input:focus {
    border:1px solid lightblue;
    outline: lightblue;
  }
  /** 
    El fragmento siguiente fue obtenido del proyecto Materializecss
    Copyright (c) 2014-2017 Materialize
  */

  .progress {
	position: relative;
	height: 4px;
	display: inline-block;
	width: 95%;
  padding: 0px;
	background-color: #acece6;
	border-radius: 2px;
	overflow: hidden;
  top:-12px;
  margin: auto;
}

.progress .indeterminate {
	background-color: #26a69a;
}

.progress .indeterminate::before {
	content: '';
	position: absolute;
	background-color: inherit;
	top: 0;
	left: 0;
	bottom: 0;
	will-change: left, right;
	-webkit-animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
	animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
}

.progress .indeterminate::after {
	content: '';
	position: absolute;
	background-color: inherit;
	top: 0;
	left: 0;
	bottom: 0;
	will-change: left, right;
	-webkit-animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
	animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
	-webkit-animation-delay: 0.5s;
	animation-delay: 0.5s;
}

</style>